__turbopack_context__.v({
  "colors": "m5LG7W_colors",
  "deviceImage": "m5LG7W_deviceImage",
  "root": "m5LG7W_root",
  "stickyContainer": "m5LG7W_stickyContainer",
  "text": "m5LG7W_text",
});
